/**
 * OAuthCallbackPage
 *
 * Handles OAuth provider callback and token exchange for admin authentication.
 * Supports: TPOS Account (OAuth2)
 *
 * Refactored to use React hooks pattern (useAdminOAuth2Callback)
 */

import { Cloud, AlertCircle, Loader2 } from "lucide-react";
import { useAdminOAuth2Callback } from "@/hooks/useAdminOAuth2Callback";

export default function OAuthCallbackPage() {
  const { status, error } = useAdminOAuth2Callback();

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-info-soft via-transparent to-info-soft dark:from-canvas dark:via-canvas dark:to-canvas p-4">
        <div className="w-full max-w-md">
          <div className="bg-card rounded-lg shadow-lg p-8 border border-border text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-destructive-soft mb-4">
              <AlertCircle className="w-8 h-8 text-destructive-ink" />
            </div>
            <h2 className="text-xl font-semibold text-foreground mb-2">
              Authentication Failed
            </h2>
            <p className="text-sm text-muted-foreground mb-4">{error}</p>
            <p className="text-xs text-muted-foreground">
              Redirecting to login page...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-info-soft via-transparent to-info-soft dark:from-canvas dark:via-canvas dark:to-canvas p-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-lg shadow-lg p-8 border border-border text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-soft mb-4">
            {status === "success" ? (
              <Cloud className="w-8 h-8 text-brand" />
            ) : (
              <Loader2 className="w-8 h-8 animate-spin text-brand" />
            )}
          </div>
          <h2 className="text-xl font-semibold text-foreground mb-2">
            {status === "success"
              ? "Sign In Successful!"
              : "Completing Sign In"}
          </h2>
          {/* The badge above already spins while loading - a second Loader2 here rendered two
              spinners on the same card. */}
          <p className="text-sm text-muted-foreground">
            {status === "success"
              ? "Redirecting to admin dashboard..."
              : "Please wait while we authenticate your admin account..."}
          </p>
        </div>
      </div>
    </div>
  );
}
